// // dashboard-frontend/src/components/VolunteerDashboard.jsx
// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { fetchJSON } from '../api';

// const VolunteerDashboard = () => {
//   const volunteer = JSON.parse(localStorage.getItem("volunteer"));
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Track which tab is active
//   const [activeTab, setActiveTab] = useState("new");

//   // Donation form state (ADD CITY)
//   const [donation, setDonation] = useState({
//     donationType: 'cash',
//     name: '',
//     phone: '',
//     email: '',
//     city: '',       // <-- NEW FIELD
//     amount: '',
//     note: '',
//     bankName: '',
//     chequeNumber: '',
//     upiTransactionId: '',
//     aadharCard: '',
//     panCard: ''
//   });

//   // Collections & deposit acknowledgment
//   const [myCollections, setMyCollections] = useState([]);
//   const [loadingCollections, setLoadingCollections] = useState(true);
//   const [selectedCollections, setSelectedCollections] = useState([]);
//   const [depositNote, setDepositNote] = useState("");

//   // Possibly force the "new" tab if location.state says so
//   useEffect(() => {
//     if (location.state?.forceTab === 'new') {
//       setActiveTab('new');
//       navigate('/volunteer/dashboard', { replace: true, state: {} });
//     }
//   }, [location, navigate]);

//   // Validation for the donation form
//   const validateFields = () => {
//     const phone = donation.phone.trim();
//     const aadhar = donation.aadharCard.trim();
//     const pan = donation.panCard.trim();
//     const amount = Number(donation.amount || 0);
//     const donationType = donation.donationType;

//     // Phone must be exactly 10 digits
//     if (!/^\d{10}$/.test(phone)) {
//       return "Phone number must be exactly 10 digits.";
//     }
//     // Aadhar must be exactly 12 digits if provided
//     if (aadhar && !/^\d{12}$/.test(aadhar)) {
//       return "Aadhar must be 12 digits if provided.";
//     }
//     // PAN must be 10 characters if provided
//     if (pan && pan.length !== 10) {
//       return "PAN must be 10 characters if provided.";
//     }
//     // Amount must be > 0
//     if (amount <= 0) {
//       return "Please enter a valid donation amount.";
//     }

//     // 1) If donation is cash, do not allow more than 9000
//     if (donationType === 'cash' && amount > 9000) {
//       return "Cannot accept cash donations above 9000 INR.";
//     }

//     // 2) If donation is cheque, enforce a 6-digit cheque number
//     if (donationType === 'cheque') {
//       const chkNum = donation.chequeNumber.trim();
//       if (!/^\d{6}$/.test(chkNum)) {
//         return "Cheque number must be exactly 6 digits.";
//       }
//     }

//     // If everything else is fine
//     return null;
//   };

//   const handleChange = (e) => {
//     setDonation({ ...donation, [e.target.name]: e.target.value });
//   };

//   // Submit new donation
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationError = validateFields();
//     if (validationError) {
//       alert(validationError);
//       return;
//     }
//     try {
//       // Pass city (and all other fields) along to the backend
//       const payload = { userId: volunteer._id, ...donation };
//       const donationData = await fetchJSON('/api/users/cash-donation', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload)
//       });
//       alert(
//         donation.donationType === 'cash'
//           ? "Cash donation recorded successfully"
//           : donation.donationType === 'cheque'
//           ? "Cheque donation recorded successfully"
//           : "UPI donation recorded successfully"
//       );
//       // Reset the form
//       setDonation({
//         donationType: 'cash',
//         name: '',
//         phone: '',
//         email: '',
//         city: '',          // reset city as well
//         amount: '',
//         note: '',
//         bankName: '',
//         chequeNumber: '',
//         upiTransactionId: '',
//         aadharCard: '',
//         panCard: ''
//       });
//       // Navigate to receipt preview
//       navigate(`/volunteer/receipt-preview?id=${donationData._id}&type=${donationData.donationType}`);
//     } catch (err) {
//       alert(err.message);
//     }
//   };

//   // Fetch volunteer’s donations
//   const fetchCollections = async () => {
//     try {
//       const data = await fetchJSON(`/api/users/my-cash-donations/${volunteer._id}`);
//       setMyCollections(data);
//     } catch (err) {
//       console.error(err);
//     }
//     setLoadingCollections(false);
//   };

//   useEffect(() => {
//     fetchCollections();
//   }, [volunteer._id]);

//   // Logout
//   const handleLogout = () => {
//     localStorage.removeItem("volunteer");
//     localStorage.removeItem("token");
//     window.location.href = "/volunteer";
//   };

//   // Preview receipt
//   const previewReceipt = (collection) => {
//     navigate(`/volunteer/receipt-preview?id=${collection._id}&type=${collection.donationType}`);
//   };

//   // Mark selected donations as deposited
//   const handleMarkDeposited = async () => {
//     try {
//       await fetchJSON('/api/users/cash-donations/acknowledge', {
//         method: 'PATCH',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           donationIds: selectedCollections,
//           depositNote: depositNote
//         })
//       });
//       alert("Deposit acknowledged successfully!");
//       setSelectedCollections([]);
//       setDepositNote("");
//       fetchCollections();
//     } catch (error) {
//       alert(error.message);
//     }
//   };

//   // Force reload if page is loaded from back button
//   useEffect(() => {
//     window.onpageshow = function (e) {
//       if (e.persisted) {
//         window.location.reload();
//       }
//     };
//   }, []);

//   return (
//     <div className="p-4">
//       <div className="flex flex-col md:flex-row justify-between items-center mb-4">
//         <h1 className="text-3xl font-bold">Volunteer Dashboard</h1>
//         <button onClick={handleLogout} className="bg-red-500 text-white px-4 py-2 rounded">
//           Logout
//         </button>
//       </div>

//       {/* Tab Navigation */}
//       <div className="mb-4 border-b">
//         <nav className="flex">
//           <button
//             onClick={() => setActiveTab("new")}
//             className={`py-2 px-4 font-bold ${activeTab === "new" ? "border-b-2 border-primary" : "text-gray-600"}`}
//           >
//             Record Donation
//           </button>
//           <button
//             onClick={() => setActiveTab("collections")}
//             className={`py-2 px-4 font-bold ${activeTab === "collections" ? "border-b-2 border-primary" : "text-gray-600"}`}
//           >
//             My Collections
//           </button>
//         </nav>
//       </div>

//       {/* New Donation Form */}
//       {activeTab === "new" && (
//         <form onSubmit={handleSubmit} className="max-w-md mx-auto space-y-4">
//           <div className="mb-2">
//             <label className="block">Donation Type</label>
//             <select
//               name="donationType"
//               value={donation.donationType}
//               onChange={handleChange}
//               className="w-full border p-2 rounded"
//             >
//               <option value="cash">Cash Donation</option>
//               <option value="cheque">Cheque Donation</option>
//               <option value="upi">UPI Donation</option>
//             </select>
//           </div>

//           <div className="mb-2">
//             <label className="block">Donor Name</label>
//             <input
//               type="text"
//               name="name"
//               value={donation.name}
//               onChange={handleChange}
//               className="w-full border p-2 rounded"
//               required
//             />
//           </div>

//           <div className="mb-2">
//             <label className="block">Phone (10 digits)</label>
//             <input
//               type="text"
//               name="phone"
//               value={donation.phone}
//               onChange={handleChange}
//               className="w-full border p-2 rounded"
//               required
//             />
//           </div>

//           <div className="mb-2">
//             <label className="block">Email (optional)</label>
//             <input
//               type="email"
//               name="email"
//               value={donation.email}
//               onChange={handleChange}
//               className="w-full border p-2 rounded"
//             />
//           </div>

//           {/* CITY FIELD - ADDED */}
//           <div className="mb-2">
//             <label className="block">City (optional)</label>
//             <input
//               type="text"
//               name="city"
//               value={donation.city}
//               onChange={handleChange}
//               className="w-full border p-2 rounded"
//               placeholder="Enter donor's city"
//             />
//           </div>
//           {/* END CITY FIELD */}

//           <div className="mb-2">
//             <label className="block">Aadhar Card (optional)</label>
//             <input
//               type="text"
//               name="aadharCard"
//               value={donation.aadharCard}
//               onChange={handleChange}
//               className="w-full border p-2 rounded"
//               placeholder="12 digits if provided"
//             />
//           </div>

//           <div className="mb-2">
//             <label className="block">PAN Card (optional)</label>
//             <input
//               type="text"
//               name="panCard"
//               value={donation.panCard}
//               onChange={handleChange}
//               className="w-full border p-2 rounded"
//               placeholder="10 characters if provided"
//             />
//           </div>

//           <div className="mb-2">
//             <label className="block">Amount (INR)</label>
//             <input
//               type="number"
//               name="amount"
//               value={donation.amount}
//               onChange={handleChange}
//               className="w-full border p-2 rounded"
//               required
//             />
//           </div>

//           {/* Cheque-specific fields */}
//           {donation.donationType === 'cheque' && (
//             <>
//               <div className="mb-2">
//                 <label className="block">Bank Name</label>
//                 <input
//                   type="text"
//                   name="bankName"
//                   value={donation.bankName}
//                   onChange={handleChange}
//                   className="w-full border p-2 rounded"
//                   required
//                 />
//               </div>
//               <div className="mb-2">
//                 <label className="block">Cheque Number (6 digits)</label>
//                 <input
//                   type="text"
//                   name="chequeNumber"
//                   value={donation.chequeNumber}
//                   onChange={handleChange}
//                   className="w-full border p-2 rounded"
//                   required
//                 />
//               </div>
//             </>
//           )}

//           {/* UPI-specific field */}
//           {donation.donationType === 'upi' && (
//             <div className="mb-2">
//               <label className="block">UPI Transaction ID</label>
//               <input
//                 type="text"
//                 name="upiTransactionId"
//                 value={donation.upiTransactionId}
//                 onChange={handleChange}
//                 className="w-full border p-2 rounded"
//                 required
//               />
//             </div>
//           )}

//           <div className="mb-2">
//             <label className="block">Note</label>
//             <textarea
//               name="note"
//               value={donation.note}
//               onChange={handleChange}
//               className="w-full border p-2 rounded"
//             />
//           </div>

//           <button type="submit" className="w-full bg-primary text-white py-2 rounded">
//             Record Donation
//           </button>
//         </form>
//       )}

//       {/* Collections Tab */}
//       {activeTab === "collections" && (
//         <div className="mt-6">
//           <h2 className="text-xl mb-4">My Previous Collections</h2>
//           <div className="mb-4 p-4 bg-white rounded shadow">
//             <h3 className="text-lg font-semibold mb-2">Mark Selected as Deposited</h3>
//             <textarea
//               placeholder="Enter deposit acknowledgment note (e.g., deposited to bank XYZ)"
//               className="w-full border p-2 rounded mb-2"
//               value={depositNote}
//               onChange={e => setDepositNote(e.target.value)}
//             />
//             <button
//               onClick={handleMarkDeposited}
//               disabled={selectedCollections.length === 0 || !depositNote}
//               className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded"
//             >
//               Mark as Deposited
//             </button>
//           </div>

//           {loadingCollections ? (
//             <p>Loading your collections...</p>
//           ) : (
//             <div className="overflow-x-auto">
//               <table className="min-w-full bg-white border text-sm">
//                 <thead>
//                   <tr>
//                     <th className="py-2 px-4 border">
//                       <input
//                         type="checkbox"
//                         onChange={e => {
//                           if (e.target.checked) {
//                             setSelectedCollections(myCollections.map(col => col._id));
//                           } else {
//                             setSelectedCollections([]);
//                           }
//                         }}
//                         checked={selectedCollections.length === myCollections.length && myCollections.length > 0}
//                       />
//                     </th>
//                     <th className="py-2 px-4 border">Donor Name</th>
//                     <th className="py-2 px-4 border">Phone</th>
//                     <th className="py-2 px-4 border">Email</th>
//                     <th className="py-2 px-4 border">Amount (INR)</th>
//                     <th className="py-2 px-4 border">Donation Type</th>
//                     <th className="py-2 px-4 border">Collected At</th>
//                     <th className="py-2 px-4 border">Receipt</th>
//                     <th className="py-2 px-4 border">Deposit Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {myCollections.map(collection => (
//                     <tr key={collection._id} className={`border-b ${collection.isDeleted ? "deleted" : ""}`}>
//                       <td className="py-2 px-4 border">
//                         <input
//                           type="checkbox"
//                           checked={selectedCollections.includes(collection._id)}
//                           onChange={e => {
//                             if (e.target.checked) {
//                               setSelectedCollections(prev => [...prev, collection._id]);
//                             } else {
//                               setSelectedCollections(prev => prev.filter(id => id !== collection._id));
//                             }
//                           }}
//                         />
//                       </td>
//                       <td className="py-2 px-4 border">{collection.name}</td>
//                       <td className="py-2 px-4 border">{collection.phone}</td>
//                       <td className="py-2 px-4 border">{collection.email}</td>
//                       <td className="py-2 px-4 border">{collection.amount}</td>
//                       <td className="py-2 px-4 border">{collection.donationType}</td>
//                       <td className="py-2 px-4 border">{new Date(collection.createdAt).toLocaleDateString()}</td>
//                       <td className="py-2 px-4 border">
//                         <button
//                           onClick={() => previewReceipt(collection)}
//                           className="bg-secondary text-white px-2 py-1 rounded"
//                         >
//                           Preview Receipt
//                         </button>
//                       </td>
//                       <td className="py-2 px-4 border">
//                         {collection.depositAcknowledged ? (
//                           <>
//                             <span className="text-green-600 font-bold">Deposited</span>
//                             <br />
//                             <small>{collection.depositNote}</small>
//                             <br />
//                             <small>{collection.depositVerified ? "Verified" : "Not Verified"}</small>
//                           </>
//                         ) : (
//                           <span className="text-red-600 font-bold">Pending</span>
//                         )}
//                       </td>
//                     </tr>
//                   ))}
//                   {myCollections.length === 0 && (
//                     <tr>
//                       <td colSpan={9} className="p-4 text-center text-gray-500">
//                         No donations recorded yet.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default VolunteerDashboard;








// dashboard-frontend/src/components/VolunteerDashboard.jsx

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { fetchJSON } from '../api';

const VolunteerDashboard = () => {
  const volunteer = JSON.parse(localStorage.getItem("volunteer"));
  const navigate = useNavigate();
  const location = useLocation();

  // Track which tab is active
  const [activeTab, setActiveTab] = useState("new");

  // Donation form state
  const [donation, setDonation] = useState({
    donationType: 'cash',
    name: '',
    phone: '',
    email: '',
    city: '',
    amount: '',
    note: '',
    bankName: '',
    chequeNumber: '',
    upiTransactionId: '',
    aadharCard: '',
    panCard: ''
  });

  // Loading and feedback states
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [submitMessageType, setSubmitMessageType] = useState(''); // 'success' or 'error'
  const [validationErrors, setValidationErrors] = useState({});

  // Recent donations state
  const [recentDonations, setRecentDonations] = useState([]);
  const [loadingRecent, setLoadingRecent] = useState(false);

  // Collections & deposit acknowledgment
  const [myCollections, setMyCollections] = useState([]);
  const [loadingCollections, setLoadingCollections] = useState(true);
  const [selectedCollections, setSelectedCollections] = useState([]);
  const [depositNote, setDepositNote] = useState("");

  // State for the acknowledgment modal
  const [showAcknowledgeModal, setShowAcknowledgeModal] = useState(false);
  const [selectedDonation, setSelectedDonation] = useState(null);
  const [acknowledgmentFields, setAcknowledgmentFields] = useState({
    depositNote: '',
    upiTransactionId: '',
    bankName: '',
    chequeNumber: ''
  });

  // Possibly force the "new" tab if location.state says so
  useEffect(() => {
    if (location.state?.forceTab === 'new') {
      setActiveTab('new');
      navigate('/volunteer/dashboard', { replace: true, state: {} });
    }
  }, [location, navigate]);

  // Helper: Only keep English letters, digits, spaces, and limited punctuation
  // Adjust the regex to your exact needs
  const sanitizeEnglish = (value) => {
    return value.replace(/[^A-Za-z0-9\s.,'/-]/g, ""); 
  };

  // Validation for the donation form - returns errors object
  const validateFields = () => {
    const phone = donation.phone.trim();
    const aadhar = donation.aadharCard.trim();
    const pan = donation.panCard.trim();
    const amount = Number(donation.amount || 0);
    const donationType = donation.donationType;
    const errors = {};

    // Required field validations
    if (!donation.name.trim()) {
      errors.name = "Donor name is required.";
    }

    // Phone must be exactly 10 digits
    if (!phone) {
      errors.phone = "Phone number is required.";
    } else if (!/^\d{10}$/.test(phone)) {
      errors.phone = "Phone number must be exactly 10 digits.";
    }

    // Amount must be > 0
    if (!donation.amount || amount <= 0) {
      errors.amount = "Please enter a valid donation amount.";
    }

    // Cash donation amount limit
    if (donationType === 'cash' && amount > 9000) {
      errors.amount = "Cannot accept cash donations above 9000 INR.";
    }

    // Aadhar must be exactly 12 digits if provided
    if (aadhar && !/^\d{12}$/.test(aadhar)) {
      errors.aadharCard = "Aadhar must be 12 digits if provided.";
    }

    // PAN must be 10 characters if provided
    if (pan && pan.length !== 10) {
      errors.panCard = "PAN must be 10 characters if provided.";
    }

    // Donation type specific validations
    if (donationType === 'cheque') {
      if (!donation.bankName.trim()) {
        errors.bankName = "Bank name is required for cheque donations.";
      }
      const chkNum = donation.chequeNumber.trim();
      if (!chkNum) {
        errors.chequeNumber = "Cheque number is required for cheque donations.";
      } else if (!/^\d{6}$/.test(chkNum)) {
        errors.chequeNumber = "Cheque number must be exactly 6 digits.";
      }
    }

    if (donationType === 'upi') {
      if (!donation.upiTransactionId.trim()) {
        errors.upiTransactionId = "UPI transaction ID is required for UPI donations.";
      }
    }

    return errors;
  };

  // Real-time handleChange for text fields: remove non-English
  const handleEnglishChange = (e) => {
    const { name, value } = e.target;
    // Sanitize to remove non-English
    const sanitized = sanitizeEnglish(value);
    setDonation({ ...donation, [name]: sanitized });
  };

  // For numeric fields like phone, aadhar, pan, or amount we can do separate logic
  const handleChange = (e) => {
    const { name, value } = e.target;
    setDonation({ ...donation, [name]: value });
  };

  // Submit new donation
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Clear previous messages and validation errors
    setSubmitMessage('');
    setSubmitMessageType('');
    setValidationErrors({});
    
    // Validate fields
    const errors = validateFields();
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setSubmitMessage('Please fix the validation errors before submitting.');
      setSubmitMessageType('error');
      return;
    }

    // Prevent multiple submissions
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    
    try {
      const payload = { userId: volunteer._id, ...donation };
      const donationData = await fetchJSON('/api/users/cash-donation', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      // Show success message
      const successMessage = donation.donationType === 'cash'
        ? "Cash donation recorded successfully!"
        : donation.donationType === 'cheque'
        ? "Cheque donation recorded successfully!"
        : "UPI donation recorded successfully!";
      
      setSubmitMessage(successMessage);
      setSubmitMessageType('success');

      // Reset the form
      setDonation({
        donationType: 'cash',
        name: '',
        phone: '',
        email: '',
        city: '',
        amount: '',
        note: '',
        bankName: '',
        chequeNumber: '',
        upiTransactionId: '',
        aadharCard: '',
        panCard: ''
      });

      // Refresh recent donations list
      await fetchRecentDonations();
      
      // Navigate to receipt preview after a short delay
      setTimeout(() => {
        navigate(`/volunteer/receipt-preview?id=${donationData._id}&type=${donationData.donationType}`);
      }, 2000);
      
    } catch (err) {
      setSubmitMessage(err.message || 'An error occurred while submitting the donation.');
      setSubmitMessageType('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Fetch volunteer’s donations
  const fetchCollections = async () => {
    try {
      const data = await fetchJSON(`/api/users/my-cash-donations/${volunteer._id}`);
      setMyCollections(data);
    } catch (err) {
      console.error(err);
    }
    setLoadingCollections(false);
  };

  // Fetch recent donations (last 5) for display under form
  const fetchRecentDonations = async () => {
    setLoadingRecent(true);
    try {
      const data = await fetchJSON(`/api/users/my-cash-donations/${volunteer._id}`);
      // Get only the 5 most recent donations
      setRecentDonations(data.slice(0, 5));
    } catch (err) {
      console.error("Error fetching recent donations:", err);
    }
    setLoadingRecent(false);
  };

  useEffect(() => {
    fetchCollections();
    fetchRecentDonations();
  }, [volunteer._id]);

  // Logout
  const handleLogout = () => {
    localStorage.removeItem("volunteer");
    localStorage.removeItem("token");
    window.location.href = "/volunteer";
  };

  // Preview receipt
  const previewReceipt = (collection) => {
    navigate(`/volunteer/receipt-preview?id=${collection._id}&type=${collection.donationType}`);
  };

  // Mark selected donations as deposited
  const handleMarkDeposited = async () => {
    try {
      await fetchJSON('/api/users/cash-donations/acknowledge', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          donationIds: selectedCollections,
          depositNote: depositNote
        })
      });
      alert("Deposit acknowledged successfully!");
      setSelectedCollections([]);
      setDepositNote("");
      fetchCollections();
    } catch (error) {
      alert(error.message);
    }
  };

  // Function to open the acknowledgment modal for a specific donation
  const openAcknowledgeModal = (donation) => {
    setSelectedDonation(donation);
    setAcknowledgmentFields({
      depositNote: donation.depositNote || '',
      upiTransactionId: donation.upiTransactionId || '',
      bankName: donation.bankName || '',
      chequeNumber: donation.chequeNumber || ''
    });
    setShowAcknowledgeModal(true);
  };

  // Handle input changes in the acknowledgment modal
  const handleAcknowledgeFieldChange = (e) => {
    setAcknowledgmentFields({
      ...acknowledgmentFields,
      [e.target.name]: e.target.value
    });
  };

  // Handle submission of the acknowledgment modal
  const handleAcknowledgeSubmit = async () => {
    if (!selectedDonation) return;
    
    try {
      await fetchJSON(`/api/users/cash-donation/${selectedDonation._id}/acknowledge`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(acknowledgmentFields),
      });
      
      // Close modal and refresh collections
      setShowAcknowledgeModal(false);
      setSelectedDonation(null);
      fetchCollections();
      
      alert('Deposit successfully acknowledged!');
    } catch (error) {
      console.error('Error acknowledging deposit:', error);
      alert('Failed to acknowledge deposit. Please try again.');
    }
  };
  
  // Force reload if page is loaded from back button
  useEffect(() => {
    window.onpageshow = function (e) {
      if (e.persisted) {
        window.location.reload();
      }
    };
  }, []);

  return (
    <div className="p-4">
      <div className="flex flex-col md:flex-row justify-between items-center mb-4">
        <h1 className="text-3xl font-bold">Volunteer Dashboard</h1>
        <button onClick={handleLogout} className="bg-red-500 text-white px-4 py-2 rounded">
          Logout
        </button>
      </div>

      {/* Tab Navigation */}
      <div className="mb-4 border-b">
        <nav className="flex">
          <button
            onClick={() => setActiveTab("new")}
            className={`py-2 px-4 font-bold ${activeTab === "new" ? "border-b-2 border-primary" : "text-gray-600"}`}
          >
            Record Donation
          </button>
          <button
            onClick={() => setActiveTab("collections")}
            className={`py-2 px-4 font-bold ${activeTab === "collections" ? "border-b-2 border-primary" : "text-gray-600"}`}
          >
            My Collections
          </button>
        </nav>
      </div>

      {/* New Donation Form */}
      {activeTab === "new" && (
        <div className="max-w-md mx-auto">
          <p className="text-red-600 font-semibold text-sm mb-2">
            IMPORTANT: Please use only <u>English letters</u> and digits in all fields. Gujarati or other scripts are not allowed.
          </p>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block">Donation Type</label>
              <select
                name="donationType"
                value={donation.donationType}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              >
                <option value="cash">Cash Donation</option>
                <option value="cheque">Cheque Donation</option>
                <option value="upi">UPI Donation</option>
              </select>
            </div>

            <div>
              <label className="block">Donor Name</label>
              <input
                type="text"
                name="name"
                value={donation.name}
                onChange={handleEnglishChange}
                className={`w-full border p-2 rounded ${validationErrors.name ? 'border-red-500' : ''}`}
                required
                placeholder="English only"
              />
              {validationErrors.name && (
                <p className="text-red-500 text-sm mt-1">{validationErrors.name}</p>
              )}
            </div>

            <div>
              <label className="block">Phone (10 digits)</label>
              <input
                type="text"
                name="phone"
                value={donation.phone}
                onChange={handleChange}
                className={`w-full border p-2 rounded ${validationErrors.phone ? 'border-red-500' : ''}`}
                required
              />
              {validationErrors.phone && (
                <p className="text-red-500 text-sm mt-1">{validationErrors.phone}</p>
              )}
            </div>

            <div>
              <label className="block">Email (optional)</label>
              <input
                type="email"
                name="email"
                value={donation.email}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              />
            </div>

            <div>
              <label className="block">City (optional)</label>
              <input
                type="text"
                name="city"
                value={donation.city}
                onChange={handleEnglishChange}
                className="w-full border p-2 rounded"
                placeholder="English only"
              />
            </div>

            <div>
              <label className="block">Aadhar Card (optional)</label>
              <input
                type="text"
                name="aadharCard"
                value={donation.aadharCard}
                onChange={handleChange}
                className={`w-full border p-2 rounded ${validationErrors.aadharCard ? 'border-red-500' : ''}`}
                placeholder="12 digits if provided"
              />
              {validationErrors.aadharCard && (
                <p className="text-red-500 text-sm mt-1">{validationErrors.aadharCard}</p>
              )}
            </div>

            <div>
              <label className="block">PAN Card (optional)</label>
              <input
                type="text"
                name="panCard"
                value={donation.panCard}
                onChange={handleChange}
                className={`w-full border p-2 rounded ${validationErrors.panCard ? 'border-red-500' : ''}`}
                placeholder="10 characters if provided"
              />
              {validationErrors.panCard && (
                <p className="text-red-500 text-sm mt-1">{validationErrors.panCard}</p>
              )}
            </div>

            <div>
              <label className="block">Amount (INR)</label>
              <input
                type="number"
                name="amount"
                value={donation.amount}
                onChange={handleChange}
                className={`w-full border p-2 rounded ${validationErrors.amount ? 'border-red-500' : ''}`}
                required
              />
              {validationErrors.amount && (
                <p className="text-red-500 text-sm mt-1">{validationErrors.amount}</p>
              )}
            </div>

            {/* Cheque-specific fields */}
            {donation.donationType === 'cheque' && (
              <>
                <div>
                  <label className="block">Bank Name</label>
                  <input
                    type="text"
                    name="bankName"
                    value={donation.bankName}
                    onChange={handleEnglishChange}
                    className={`w-full border p-2 rounded ${validationErrors.bankName ? 'border-red-500' : ''}`}
                    required
                    placeholder="English only"
                  />
                  {validationErrors.bankName && (
                    <p className="text-red-500 text-sm mt-1">{validationErrors.bankName}</p>
                  )}
                </div>
                <div>
                  <label className="block">Cheque Number (6 digits)</label>
                  <input
                    type="text"
                    name="chequeNumber"
                    value={donation.chequeNumber}
                    onChange={handleChange}
                    className={`w-full border p-2 rounded ${validationErrors.chequeNumber ? 'border-red-500' : ''}`}
                    required
                  />
                  {validationErrors.chequeNumber && (
                    <p className="text-red-500 text-sm mt-1">{validationErrors.chequeNumber}</p>
                  )}
                </div>
              </>
            )}

            {/* UPI-specific field */}
            {donation.donationType === 'upi' && (
              <div>
                <label className="block">UPI Transaction ID</label>
                <input
                  type="text"
                  name="upiTransactionId"
                  value={donation.upiTransactionId}
                  onChange={handleEnglishChange}
                  className={`w-full border p-2 rounded ${validationErrors.upiTransactionId ? 'border-red-500' : ''}`}
                  required
                  placeholder="English only"
                />
                {validationErrors.upiTransactionId && (
                  <p className="text-red-500 text-sm mt-1">{validationErrors.upiTransactionId}</p>
                )}
              </div>
            )}

            <div>
              <label className="block">Note</label>
              <textarea
                name="note"
                value={donation.note}
                onChange={handleEnglishChange}
                className="w-full border p-2 rounded"
                placeholder="English only"
              />
            </div>

            {/* Submit Message Display */}
            {submitMessage && (
              <div className={`p-3 rounded mb-4 ${
                submitMessageType === 'success' 
                  ? 'bg-green-100 text-green-700 border border-green-300' 
                  : 'bg-red-100 text-red-700 border border-red-300'
              }`}>
                {submitMessage}
              </div>
            )}

            <button 
              type="submit" 
              disabled={isSubmitting}
              className={`w-full py-3 rounded font-semibold ${
                isSubmitting 
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-primary hover:bg-primary-dark text-white'
              } transition-colors`}
            >
              {isSubmitting ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Submitting...
                </span>
              ) : (
                'Record Donation'
              )}
            </button>
          </form>

          {/* Recent Donations Display */}
          <div className="mt-8">
            <h3 className="text-lg font-semibold mb-4">Your Recent Donations (Last 5)</h3>
            {loadingRecent ? (
              <div className="flex justify-center p-4">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
              </div>
            ) : recentDonations.length > 0 ? (
              <div className="bg-white rounded shadow overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="min-w-full">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Receipt</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {recentDonations.map((donation, index) => (
                        <tr key={donation._id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                          <td className="px-3 py-2 text-sm text-gray-900">
                            {new Date(donation.createdAt).toLocaleDateString()}
                          </td>
                          <td className="px-3 py-2 text-sm text-gray-900">{donation.name}</td>
                          <td className="px-3 py-2 text-sm text-gray-900">{donation.phone}</td>
                          <td className="px-3 py-2 text-sm text-gray-900">₹{donation.amount}</td>
                          <td className="px-3 py-2 text-sm">
                            <span className={`px-2 py-1 text-xs rounded-full ${
                              donation.donationType === 'cash' ? 'bg-green-100 text-green-800' :
                              donation.donationType === 'cheque' ? 'bg-blue-100 text-blue-800' :
                              'bg-purple-100 text-purple-800'
                            }`}>
                              {donation.donationType.toUpperCase()}
                            </span>
                          </td>
                          <td className="px-3 py-2 text-sm">
                            <button
                              onClick={() => previewReceipt(donation)}
                              className="text-primary hover:text-primary-dark font-medium"
                            >
                              {donation.receiptNumber}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="text-center p-6 bg-white rounded shadow">
                <p className="text-gray-500">No donations recorded yet.</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Collections Tab */}
      {activeTab === "collections" && (
        <div className="mt-6">
          <h2 className="text-xl mb-4">My Previous Collections</h2>
          <div className="mb-4 p-4 bg-white rounded shadow">
            <h3 className="text-lg font-semibold mb-2">Mark Selected as Deposited</h3>
            <textarea
              placeholder="Enter deposit acknowledgment note (e.g., deposited to bank XYZ)"
              className="w-full border p-2 rounded mb-2"
              value={depositNote}
              onChange={e => setDepositNote(e.target.value)}
            />
            <button
              onClick={handleMarkDeposited}
              disabled={selectedCollections.length === 0 || !depositNote}
              className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded"
            >
              Mark as Deposited
            </button>
          </div>

          {loadingCollections ? (
            <p>Loading your collections...</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border text-sm">
                <thead>
                  <tr>
                    <th className="py-2 px-4 border">
                      <input
                        type="checkbox"
                        onChange={e => {
                          if (e.target.checked) {
                            setSelectedCollections(myCollections.map(col => col._id));
                          } else {
                            setSelectedCollections([]);
                          }
                        }}
                        checked={selectedCollections.length === myCollections.length && myCollections.length > 0}
                      />
                    </th>
                    <th className="py-2 px-4 border">Donor Name</th>
                    <th className="py-2 px-4 border">Phone</th>
                    <th className="py-2 px-4 border">Email</th>
                    <th className="py-2 px-4 border">Amount (INR)</th>
                    <th className="py-2 px-4 border">Donation Type</th>
                    <th className="py-2 px-4 border">Collected At</th>
                    <th className="py-2 px-4 border">Receipt</th>
                    <th className="py-2 px-4 border">Deposit Status</th>
                    <th className="py-2 px-4 border">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {myCollections.map(collection => (
                    <tr key={collection._id} className={`border-b ${collection.isDeleted ? "deleted" : ""}`}>
                      <td className="py-2 px-4 border">
                        <input
                          type="checkbox"
                          checked={selectedCollections.includes(collection._id)}
                          onChange={e => {
                            if (e.target.checked) {
                              setSelectedCollections(prev => [...prev, collection._id]);
                            } else {
                              setSelectedCollections(prev => prev.filter(id => id !== collection._id));
                            }
                          }}
                        />
                      </td>
                      <td className="py-2 px-4 border">{collection.name}</td>
                      <td className="py-2 px-4 border">{collection.phone}</td>
                      <td className="py-2 px-4 border">{collection.email}</td>
                      <td className="py-2 px-4 border">{collection.amount}</td>
                      <td className="py-2 px-4 border">{collection.donationType}</td>
                      <td className="py-2 px-4 border">{new Date(collection.createdAt).toLocaleDateString()}</td>
                      <td className="py-2 px-4 border">
                        <button
                          onClick={() => previewReceipt(collection)}
                          className="bg-secondary text-white px-2 py-1 rounded"
                        >
                          Preview Receipt
                        </button>
                      </td>
                      <td className="py-2 px-4 border">
                        {collection.depositAcknowledged ? (
                          <>
                            <span className="text-green-600 font-bold">Deposited</span>
                            <br />
                            <small>{collection.depositNote}</small>
                            <br />
                            <small>{collection.depositVerified ? "Verified" : "Not Verified"}</small>
                          </>
                        ) : (
                          <span className="text-red-600 font-bold">Pending</span>
                        )}
                      </td>
                      <td className="py-2 px-4 border">
                        <button
                          onClick={() => openAcknowledgeModal(collection)}
                          className="bg-blue-500 text-white px-2 py-1 rounded"
                        >
                          Acknowledge Deposit
                        </button>
                      </td>
                    </tr>
                  ))}
                  {myCollections.length === 0 && (
                    <tr>
                      <td colSpan={10} className="p-4 text-center text-gray-500">
                        No donations recorded yet.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Acknowledgment Modal */}
      {showAcknowledgeModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="bg-black bg-opacity-50 absolute inset-0"></div>
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full z-10">
            <h2 className="text-xl font-semibold mb-4">Acknowledge Deposit</h2>
            
            <div className="mb-4">
              <label className="block text-sm font-medium mb-2">Deposit Note</label>
              <textarea
                name="depositNote"
                value={acknowledgmentFields.depositNote}
                onChange={handleAcknowledgeFieldChange}
                className="w-full border p-2 rounded"
                placeholder="Enter deposit note"
              />
            </div>

            {selectedDonation && selectedDonation.donationType === 'upi' && (
              <div className="mb-4">
                <label className="block text-sm font-medium mb-2">UPI Transaction ID</label>
                <input
                  type="text"
                  name="upiTransactionId"
                  value={acknowledgmentFields.upiTransactionId}
                  onChange={handleAcknowledgeFieldChange}
                  className="w-full border p-2 rounded"
                  placeholder="Enter UPI transaction ID"
                />
              </div>
            )}

            {selectedDonation && selectedDonation.donationType === 'cheque' && (
              <>
                <div className="mb-4">
                  <label className="block text-sm font-medium mb-2">Bank Name</label>
                  <input
                    type="text"
                    name="bankName"
                    value={acknowledgmentFields.bankName}
                    onChange={handleAcknowledgeFieldChange}
                    className="w-full border p-2 rounded"
                    placeholder="Enter bank name"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium mb-2">Cheque Number</label>
                  <input
                    type="text"
                    name="chequeNumber"
                    value={acknowledgmentFields.chequeNumber}
                    onChange={handleAcknowledgeFieldChange}
                    className="w-full border p-2 rounded"
                    placeholder="Enter cheque number"
                  />
                </div>
              </>
            )}

            <div className="flex justify-end space-x-3 mt-6">
              <button
                onClick={() => setShowAcknowledgeModal(false)}
                className="px-4 py-2 border rounded text-gray-700 hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={handleAcknowledgeSubmit}
                className="px-4 py-2 bg-primary text-white rounded hover:bg-primary-dark"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VolunteerDashboard;
